export const isLocalPath = () => {
    return window.location.hostname == 'localhost';
}

export const isChasRuPath = () => {
    return window.location.hostname == 'chas.puzzlebot.ru';
}

export const isCpRuPath = () => {
    return window.location.hostname == 'cp.puzzlebot.ru';
}

export const getLandingHostName = () => {
    return isLocalPath() ? window.location.host : (isChasRuPath() ? 'chas.puzzlebot.ru' : (isCpRuPath() ? 'cp.puzzlebot.ru' : 'help.puzzlebot.top'));
}

export const getSslProtocol = () => {
    return isLocalPath() || isChasRuPath() || isCpRuPath() ? 'http' : 'https';
}

export const getLandingPathOrigin = () => {
    return `${getSslProtocol()}://${getLandingHostName()}`;
}

